import styled from '@emotion/styled'

import type { FC, PropsWithChildren } from 'react'

import ButtonText from '@segment/matcha/components/ButtonText'

import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import HeroBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'

import { trackButtonClick } from '@segment/tracking/scripts'

import useStartupLinks from '@segment/utils/useStartupLinks'

import heroPng2x from './assets/HeroIndustryStartups@2x.png'
import heroWebp from './assets/HeroIndustryStartups.webp'
import heroWebp2x from './assets/HeroIndustryStartups@2x.webp'
import heroWebp3x from './assets/HeroIndustryStartups@3x.webp'

const copy = {
  heading: <>The ultimate analytics setup is&nbsp;now free</>,
  description: `Collecting and analyzing customer data is critical to finding product-market fit. That’s why we’re giving early-stage startups Segment for free for up to two years when you join our Startup Program—along with other perks.`,
}

const link = {
  text: `Apply now`,
}

const Hero: FC<PropsWithChildren<unknown>> = () => {
  const { applyLink } = useStartupLinks()

  return (
    <Wrapper>
      <HeroBase variant="2Col">
        <HeroRecipe.Copy>
          <CopyTextBase>
            <CopyText.Heading variant="h1" tag="h1">
              {copy.heading}
            </CopyText.Heading>
            <CopyText.Description variant="pExtraLarge" tag="p">
              {copy.description}
            </CopyText.Description>
          </CopyTextBase>
          <HeroRecipe.Form>
            <ButtonText
              tag="a"
              href={applyLink}
              onClick={() => trackButtonClick({ buttonText: link.text, targetUrl: applyLink })}
              iconEnd={ChevronRightIcon}
            >
              {link.text}
            </ButtonText>
          </HeroRecipe.Form>
        </HeroRecipe.Copy>
        <HeroRecipe.Contents>
          <Picture>
            <source type="image/webp" srcSet={`${heroWebp}, ${heroWebp2x} 2x, ${heroWebp3x} 3x`} />
            <HeroRecipe.Image width="626" height="404" src={heroPng2x} alt="Illustration: Industry Startups Hero" />
          </Picture>
        </HeroRecipe.Contents>
      </HeroBase>
    </Wrapper>
  )
}

const Wrapper = styled.header`
  background: ${({ theme }) => theme.palette.twilio.green[10]};
`

const Picture = styled.picture`
  filter: drop-shadow(${({ theme }) => theme.shadows[2]});
`

export default Hero
